// extracted by mini-css-extract-plugin
export default {"page-title":"icon-button_page-title__wTIbk","container":"icon-button_container__atndu"};